export const ROUTES = {
  Main: '/',
  Works: '/works/*'
}
